export enum Civilite {
  Madame = 'Madame',
  Monsieur = 'Monsieur',
  Autre = 'Autre'
}
